const reviewOrder = 'Review your order';

export const pageHeaders = [
  {
    page: 'progressiveplan',
    title: 'Progressive Plan',
    backIcon: true,
  },
  {
    page: 'streamlineordering',
    title: 'Streamline Ordering',
    backIcon: true,
  },
  {
    page: 'addons',
    title: 'Enhance your service',
    backIcon: true,
  },
  {
    page: 'setup',
    title: 'Setup options',
    backIcon: true,
  },
  {
    page: 'cart',
    title: 'Cart Details',
    backIcon: true,
  },
  {
    page: 'contactinfo',
    title: 'Contact Information',
    backIcon: true,
  },
  {
    page: 'shipping',
    title: 'Shipping Information',
    backIcon: true,
  },
  {
    page: 'expresscheckout',
    title: reviewOrder,
    backIcon: true,
  },
  {
    page: 'orderreview',
    title: reviewOrder,
    backIcon: true,
  },
  {
    page: 'expresstos',
    title: 'Complete your order',
    backIcon: true,
  },
  {
    page: 'payment',
    title: 'Payment Details',
    backIcon: true,
  },
  {
    page: 'creditcheck',
    title: 'Credit Check',
    backIcon: true,
  },
  {
    page: 'creditstatus',
    title: 'Credit status',
    backIcon: false,
  },
  {
    page: 'appointment',
    title: 'Appointment Details',
    backIcon: true,
  },
  {
    page: 'popularplan',
    title: 'Popular Plan',
    backIcon: true,
  },
];
